<div class="pt-20 pb-20 pl-2rem pr-2rem" *ngIf="channelAffinityS.channelConversions">
  <div>{{ 'reports.channel_affinity.sentence' | translate:{
    channel: channelAffinityS.channel,
    conversions: channelAffinityS.channelConversions,
    percentOfConversions: channelAffinityS.percentOfChannelConversions.toFixed(2),
    totalConversions: channelAffinityS.totalConversions,
    conversionName: channelAffinityS.conversion
  } }}</div>
</div>
